module.exports = __webpack_public_path__ + "img/check.7361a431.png";